import { differenceInDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { useApplicationConfig } from '@bonusly/application';
import { ArrowRightSolid, Button, CalendarSolid, Link, Stack, Text } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';
import { joinPath } from '@bonusly/http';
import { useCurrentCompany } from '@bonusly/who-am-i';

export function TrialBanner() {
	const keyPrefix = 'trial_banner';
	const { t } = useTranslation('vertical_navbar', { keyPrefix });
	const company = useCurrentCompany();
	const dispatch = useDispatch();
	const origin = useApplicationConfig('recognizeOrigin');
	if (company.status !== 'in_trial' || company.is_superadmin_initialized) return; //Don't show the banner if not in trial or superadmin-initialized

	const count = differenceInDays(new Date(company.trial_end_date), new Date());

	return (
		<Stack alignItems="center" bgColor="success.datavizMid" gap={3} m={1} mb={2} mt={3} p={4} rounded="sm">
			<Text color="text.onColor" size="sm" textAlign="center">
				<CalendarSolid position="relative" size="xs" top={0.5} /> <strong>{t('days', { count })}</strong> {t('left_in_trial')}
			</Text>
			<Button
				bgColor="transparent"
				border="1px solid white"
				fontSize="sm"
				fontWeight="medium"
				onClick={() => dispatch('open-user-invite-modal')}
				size="sm"
				w="100%"
				_hover={{ bgColor: 'transparent' }}
				_active={{ bgColor: 'transparent' }}
			>
				{t('invite_teammate')}
			</Button>
			<Link
				alignItems="center"
				display="flex"
				color="text.onColor"
				fontSize="sm"
				fontWeight="medium"
				gap={2}
				href={joinPath(origin, '/company/billing')}
				_hover={{ textDecor: 'none' }}
			>
				{t('manage_plan')} <ArrowRightSolid size="xs" />
			</Link>
		</Stack>
	);
}
